import { Platform } from "react-native";
import { theme } from "../../theme/theme";
import StyleSheet from "react-native-media-query";
import { isTablet } from "react-native-device-info";

export const { styles, ids } = StyleSheet.create({
  policyActionTiles: {
    position: "relative",
    left: theme.spacing.none,
    right: theme.spacing.none,
    top: theme.spacing.none,
    bottom: theme.spacing.none,

    "@media (min-width: 200px)": {
      left: -89,
      top: 50,
      transform: [{ scale: 0.86 }],
    },
    "@media (min-width: 385px)": {
      transform: [{ scale: 0.9 }],
      top: 50,
      left: -80,
    },
    "@media (min-width: 600px)": {
      transform: [{ scale: 0.6 }],
      left: -70,
    },
    "@media (min-width: 700px)": {
      transform: [{ scale: 0.6 }],
      left: -70,
    },
    "@media (min-width: 900px)": {
      transform: [{ scale: 0.7 }],
      left: 40,
    },
    "@media (min-width: 1150px)": {
      transform: [{ scale: 0.9 }],
      top: 70,
      left: 70,
    },
    "@media (min-width: 1400px)": {
      transform: [{ scale: 1 }],
      top: 70,
      left: 70,
    },
    ...Platform.select({
      ios: {
        marginLeft: isTablet() ? 0 : -20,
        "@media (min-width: 600px)": {
          top: 120,
        },
        "@media (min-width: 700px)": {
          top: 120,
        },
        "@media (min-width: 900px)": {
          // transform: [{ scale: 0.98 }],
          marginLeft: 20,
          top: 120,
        },
        "@media (width: 1024px)": {
          transform: [{ scale: 1.2 }],
          marginLeft: 120,
          top: 120,
        },
        "@media (min-width: 1200px)": {
          transform: [{ scale: 1.2 }],
          marginLeft: 120,
          top: 120,
        },
      },
      android: {
        marginLeft: isTablet() ? 0 : -20,
        "@media (min-width: 600px)": {
          // top: -20,
        },
        "@media (min-width: 700px)": {
          // top: 120,
        },
        "@media (min-width: 900px)": {},
      },
      web: {
        "@media (min-width: 220px)": {},
        "@media (min-width: 400px)": {
          marginLeft: "10%",
        },
        "@media (min-width: 600px)": {
          // marginLeft: "0%",
        },
        "@media (min-width: 700px)": {
          // marginLeft: "0%",
        },
        "@media (min-width: 800px)": {
          marginLeft: "15%",
        },
        "@media (min-width: 900px)": {
          marginLeft: "20%",
        },
      },
    }),
  },
  agent: {
    fontWeight: theme.fontweight.medium,
    fontFamily: theme.fontFamily.robotoSlabBold,
    backgroundColor: theme.colors.tiles.agent,
    borderRadius: theme.radius.cs,
    transform: [{ rotate: "45deg" }],
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    textAlign: "center",

    "@media (min-width: 200px)": {
      // iPhone 7, 8
      width: 160,
      height: 160,
      top: 210,
      left: 335,
    },
    "@media (min-width: 700px)": {
      width: 230,
      height: 230,
      left: 615,
      top: 260,
    },
    "@media (min-width: 900px)": {
      width: 250,
      height: 250,
      left: 630,
      top: 290,
    },

    ...Platform.select({
      ios: {
        "@media (min-width: 200px)": {
          // iPhone 7, 8

          width: 170,
          height: 170,
          top: 210,
          left: 335,
        },
        "@media (min-width: 700px)": {
          width: 230,
          height: 230,
          left: 615,
          top: 260,
        },
        "@media (min-width: 900px)": {
          width: 230,
          height: 230,
          left: 615,
          top: 260,
        },
      },
    }),
  },
  docs: {
    backgroundColor: theme.colors.primary,
    borderRadius: theme.radius.cs,
    width: 250,
    height: 250,
    transform: [{ rotate: "45deg" }],
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.colors.white,

    "@media (min-width: 200px)": {
      // iPhone 7, 8
      width: 200,
      height: 200,
      top: 0,
      left: 228,
      display: "flex",
    },
    "@media (min-width: 700px)": {
      fontWeight: theme.fontweight.medium,
      width: 230,
      height: 230,
      top: 0,
      left: 535,
    },
    "@media (min-width: 900px)": {
      fontWeight: theme.fontweight.medium,
      width: 250,
      height: 250,
      top: 0,
      left: 535,
    },
    ...Platform.select({
      ios: {
        "@media (min-width: 200px)": {
          // iPhone 7, 8
          width: 200,
          height: 200,
          top: 0,
          left: 228,
          display: "flex",
        },
        "@media (min-width: 700px)": {
          fontWeight: theme.fontweight.medium,
          width: 230,
          height: 230,
          top: 0,
          left: 535,
        },
        "@media (min-width: 900px)": {
          fontWeight: theme.fontweight.medium,
          width: 230,
          height: 230,
          top: 0,
          left: 535,
        },
      },
    }),
  },
  claim: {
    backgroundColor: theme.colors.secondary,
    borderRadius: theme.radius.cs,
    transform: [{ rotate: "45deg" }],
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",

    "@media (min-width: 200px)": {
      // iPhone 7, 8
      width: 180,
      height: 180,
      top: 163,
      left: 100,
      fontWeight: theme.fontweight.medium,
    },
    "@media (min-width: 700px)": {
      width: 230,
      height: 230,
      top: 170,
      left: 365,
    },
    "@media (min-width: 900px)": {
      width: 250,
      height: 250,
      top: 190,
      left: 345,
    },
    ...Platform.select({
      ios: {
        "@media (min-width: 200px)": {
          // iPhone 7, 8
          width: 180,
          height: 180,
          top: 163,
          left: 100,
          fontWeight: theme.fontweight.medium,
        },
        "@media (min-width: 700px)": {
          width: 230,
          height: 230,
          top: 170,
          left: 365,
        },
        "@media (min-width: 900px)": {
          width: 230,
          height: 230,
          top: 170,
          left: 365,
        },
      },
    }),
  },
  payment: {
    fontFamily: theme.fontFamily.robotoSlabBold,
    fontWeight: theme.fontweight.medium,
    backgroundColor: theme.colors.primary,
    borderRadius: theme.radius.cs,
    transform: [{ rotate: "45deg" }],
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textShadowRadius: 2,
    color: theme.colors.white,

    "@media (min-width: 200px)": {
      // iPhone 7, 8
      top: 335,
      left: 212,
      width: 160,
      height: 160,
    },
    "@media (min-width: 700px)": {
      width: 230,
      height: 230,
      top: 340,
      left: 195,
    },
    "@media (min-width: 900px)": {
      width: 250,
      height: 250,
      top: 380,
      left: 155,
    },
    ...Platform.select({
      ios: {
        "@media (min-width: 200px)": {
          // iPhone 7, 8
          top: 345,
          left: 202,
          width: 170,
          height: 170,
        },
        "@media (min-width: 700px)": {
          width: 230,
          height: 230,
          top: 340,
          left: 195,
        },
        "@media (min-width: 900px)": {
          width: 230,
          height: 230,
          top: 340,
          left: 195,
        },
      },
    }),
  },
  squareGreen: {
    transform: [{ rotate: "45deg" }],
    backgroundColor: theme.colors.tiles.squareRight,
    borderRadius: theme.radius.cs,
    position: "absolute",

    "@media (min-width: 200px)": {
      display: "none",
    },
    "@media (min-width: 660px)": {
      display: "flex",
      width: 120,
      height: 120,
      top: 485,
      left: 765,
      transform: [{ rotate: "45deg" }, { scale: 0.8 }],
    },
    "@media (min-width: 768px)": {
      display: "flex",
      top: 485,
      left: 760,
      transform: [{ rotate: "45deg" }, { scale: 0.9 }],
    },
    "@media (min-width: 853px)": {
      display: "flex",
      top: 480,
      left: 780,
      transform: [{ rotate: "45deg" }, { scale: 1 }],
    },
    "@media (min-width: 900px)": {
      display: "flex",
      top: 540,
      left: 795,
      transform: [{ rotate: "45deg" }, { scale: 1 }],
    },
    ...Platform.select({
      ios: {
        "@media (min-width: 660px)": {
          display: "flex",
          width: 120,
          height: 120,
          top: 485,
          left: 765,
          transform: [{ rotate: "45deg" }, { scale: 0.8 }],
        },
        "@media (min-width: 768px)": {
          display: "flex",
          top: 485,
          left: 760,
          transform: [{ rotate: "45deg" }, { scale: 0.9 }],
        },
        "@media (min-width: 853px)": {
          display: "flex",
          top: 485,
          left: 760,
          transform: [{ rotate: "45deg" }, { scale: 0.9 }],
        },
        "@media (min-width: 900px)": {
          display: "flex",
          top: 485,
          left: 760,
          transform: [{ rotate: "45deg" }, { scale: 0.9 }],
        },
      },
    }),
  },
  squareGraphic: {
    width: 95,
    height: 95,
    position: "absolute",
    top: 230,
    left: 189,
    display: "none",
    transform: [{ rotate: "-45deg" }],

    "@media (min-width: 200px)": {
      //android small screen
      display: "none",
    },
    "@media (min-width: 700px)": {
      //android small screen
      display: "block",
    },
    "@media (min-width: 900px)": {
      //android small screen
      display: "block",
    },
    ...Platform.select({
      ios: {
        "@media (min-width: 200px)": {
          //android small screen
          display: "none",
        },
        "@media (min-width: 700px)": {
          //android small screen
          display: "block",
        },
        "@media (min-width: 900px)": {
          //android small screen
          display: "block",
        },
      },
    }),
  },
  squareBlue: {
    width: 120,
    height: 120,
    transform: [{ rotate: "45deg" }],
    backgroundColor: theme.colors.secondary + 60,
    borderRadius: theme.radius.cs,
    position: "absolute",

    display: "none",
    "@media (min-width: 700px)": {
      display: "block",
      top: 495,
      left: 85,
    },
    "@media (min-width: 900px)": {
      display: "block",
      top: 550,
      left: 35,
    },
    ...Platform.select({
      ios: {
        display: "none",
        "@media (min-width: 700px)": {
          display: "block",
          top: 495,
          left: 85,
        },
        "@media (min-width: 900px)": {
          display: "block",
          top: 495,
          left: 85,
        },
      },
    }),
  },
  videoBlock: {
    width: 320,
    height: 320,
    transform: [{ rotate: "45deg" }],
    backgroundColor: theme.colors.black + 30,
    borderRadius: theme.radius.cs,
    position: "absolute",

    display: "none",

    "@media (min-width: 700px)": {
      top: 450,
      left: 400,
      display: "block",
    },
    "@media (min-width: 900px)": {
      top: 495,
      left: 403,
      display: "block",
    },
    ...Platform.select({
      ios: {
        "@media (min-width: 700px)": {
          top: 450,
          left: 400,
          display: "block",
        },
        "@media (min-width: 900px)": {
          top: 450,
          left: 400,
          display: "block",
        },
      },
    }),
  },

  textServices: {
    fontFamily: theme.fontFamily.robotoSlabBold,
    transform: [{ rotate: "-45deg" }],
    color: theme.colors.white,
    width: "92%",
    textAlign: "center",

    "@media (min-width: 200px)": {
      fontSize: theme.fontsize.mmd,
    },
    "@media (min-width: 385px)": {
      fontSize: theme.fontsize.lg,
    },
    "@media (min-width: 485px)": {
      fontSize: theme.fontsize.lg,
    },
    "@media (min-width: 700px)": {
      fontSize: theme.fontsize.xxl,
    },

    ...Platform.select({
      web: {
        "@media (min-width: 200px)": {
          fontSize: theme.fontsize.mmd,
        },
        "@media (min-width: 385px)": {
          fontSize: theme.fontsize.lg,
          fontWeight: theme.fontweight.bold,
        },
        "@media (min-width: 485px)": {
          fontSize: theme.fontsize.lg,
          fontWeight: theme.fontweight.bold,
        },
        "@media (min-width: 700px)": {
          fontSize: theme.fontsize.xxl,
        },
      },
    }),
  },
  textServicesPayment: {
    textShadowOffset: { width: 0, height: 0 },
    textShadowRadius: 0,
  },
  textServicesAgent: {
    ...Platform.select({
      ios: {
        marginRight: theme.margin.reg,
      },
    }),
  },
  textServicesClaim: {
    ...Platform.select({
      ios: {
        paddingLeft: theme.spacing.lg,
      },
    }),
  },

  squareGraphicInner: {
    overflow: "hidden",
    borderRadius: theme.radius.cs,
    width: 95,
    height: 95,
    top: 0,
    left: 0,
  },
  homeIcon: {
    width: 217,
    height: 135,
    top: -24,
    left: -56,
    transform: [{ rotate: "45deg" }],
  },
  makeClaimIcon: {
    "@media (min-width: 200px)": {
      // iPhone 7, 8
      width: 82,
      height: 250,
    },
    "@media (min-width: 385px)": {
      // iPhone 11, 12
      width: 82,
      height: 250,
    },
    "@media (min-width: 700px)": {
      // for ipad
      width: 102,
      height: 270,
    },

    position: "absolute",
    transform: [{ rotate: "-45deg" }],
  },
  contactAgentIcon: {
    width: "80%",
    height: "80%",
    position: "absolute",
    transform: [{ rotate: "-45deg" }],
  },
  makePaymentIcon: {
    "@media (min-width: 200px)": {
      // iPhone 7, 8
      width: 102,
      height: 240,
    },
    "@media (min-width: 385px)": {
      // iPhone 11, 12
      width: 102,
      height: 240,
    },
    "@media (min-width: 700px)": {
      // for ipad
      width: 102,
      height: 240,
    },

    position: "absolute",
    transform: [{ rotate: "-45deg" }],
  },
  docsInfoIcon: {
    "@media (min-width: 200px)": {
      // iPhone 7, 8
      width: 85,
      height: 115,
    },
    "@media (min-width: 385px)": {
      // iPhone 11, 12
      width: 85,
      height: 115,
    },
    "@media (min-width: 700px)": {
      // for ipad
      width: 131,
      height: 178,
    },

    position: "absolute",
    transform: [{ rotate: "-45deg" }],
  },
  actionTabsOrientationChange: {
    flexDirection: "row",
    gap: theme.margin.reg,
    marginVertical: theme.margin.reg,
    "@media (max-width: 485px)": {
      flexDirection: "column",
    },
  },
  actionTabsContainer: {
    width: "100%",
    paddingHorizontal: "4%",

    "@media (min-width: 485px)": {
      paddingHorizontal: "8%",
    },
    "@media (min-width: 600px)": {
      paddingHorizontal: "12%",
    },
    "@media (min-width: 750px)": {
      paddingHorizontal: isTablet() ? theme.margin.lg : "16%",
    },
    marginTop: theme.margin.reg,
    flexDirection: "column",
    justifyContent: "center",
  },
  billingTabIconStyle: {
    width: 40,
    height: 70,
    marginRight: 20,
    ...Platform.select({
      android: {
        width: 70,
        height: 100,
        marginRight: 0,
        "@media (min-width: 600px)": {
          width: 30,
          height: 50,
        },
      },
      ios: {
        width: 70,
        height: 100,
        marginRight: 0,
        "@media (min-width: 600px)": {
          width: 30,
          height: 50,
        },
      },
    }),
  },
  docsTabIconStyle: {
    width: 50,
    height: 70,
    marginRight: 20,
    ...Platform.select({
      android: {
        width: 70,
        height: 90,
        marginRight: 0,
        "@media (min-width: 600px)": {
          width: 40,
          height: 60,
        },
      },
      ios: {
        width: 70,
        height: 90,
        marginRight: 0,
        "@media (min-width: 600px)": {
          width: 40,
          height: 60,
        },
      },
    }),
  },
  actionTabBottomContainer: { marginBottom: 100, gap: 8, flexDirection: "row" },
  tileContainerStyle: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 32,
    cursor: "pointer",
    flexDirection: "row",
  },
  tileContainerStyleOrientation: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 32,
    cursor: "pointer",
    flexDirection: "row",
    "@media (max-width: 485px)": {
      flexDirection: "column",
      height: 200,
    },
  },
  containerStyle: {
    "@media (min-width: 300px)": {
      width: "100%",
      height: 160,
      minHeight: 160,
      justifyContent: "space-around",
    },
  },
  textStyleContainer: {
    textAlign: "left",

    marginLeft: "10%",
    width: "80%",
  },
});
